export const wrapInput = (onChange: (fieldName: string, value: string) => void) => {
    return (e: any) => {
        onChange(e.target.name, e.target.value);
    };
};
export const wrapCheckbox = (onChange: (fieldName: string, value: string, checked: boolean) => void) => {
    return (e: any) => {
        onChange(e.target.name, e.target.value, e.target.checked);
    };
};
